import { combineReducers } from "redux";
import commonOnePlatFormReducer from "@frameworks/web/redux/reducers/common/commonReducer";
import { ALERTS_OVERVIEW, } from "@frameworks/web/redux/interfaces/Reports/iAccountOverview";
const initAlertOverView = {
    alertsOverview: {
        ASM: [],
        GSM: [],
        FNO: [],
        Ageing: [],
    },
};
const AlertsOverviewReducer = (state = initAlertOverView, action) => {
    switch (action.type) {
        case ALERTS_OVERVIEW:
            return Object.assign(Object.assign({}, state), { alertsOverview: action.payload.alertsOverview });
        default:
            return Object.assign({}, state);
    }
};
export default combineReducers({
    reducersData: AlertsOverviewReducer,
    commonData: commonOnePlatFormReducer,
});
